const replaceDots = (string) => string.replace(/\./g, '_');

export default replaceDots;
